{
  "loading": "Φόρτωση...",
  "loadingMore": "Φόρτωση περισσότερων..."
}
